// extracted by mini-css-extract-plugin
export default {"licenseBodyWrapper":"LicenseMandate_licenseBodyWrapper__zT8NE"};